import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    navpopupShow: false,
    index: 0
  },
  mutations: {
    setNavpopupShow (state, val) {
      state.navpopupShow = val
    },
    setIndex (state, val) {
      state.index = val
    }
  },
  actions: {
  },
  modules: {
  }
})
